/**
 * Customer drawer, profile and the API error codes the cashier sees most. The customer keys are
 * unprefixed because they predate the area files; renaming them would touch every caller.
 */
export default {
  // API error codes (unknown codes show the server's English message)
  'error.OUT_OF_STOCK': 'This item is out of stock.',
  'error.INSUFFICIENT_STOCK': 'Not enough stock for this quantity.',
  'error.TOTAL_MISMATCH': 'The till and the server disagree about the total. Nothing was charged; check the bill.',
  'error.PAYMENT_DOES_NOT_SETTLE': 'The payments do not add up to the bill total.',
  'error.SHIFT_NOT_OPEN': 'Your shift is not open. Open a shift to bill.',
  'error.TAX_EXEMPT_NOT_PERMITTED': 'You are not allowed to remove tax. Ask a manager.',
  'error.OPEN_ITEM_NOT_PERMITTED': 'You are not allowed to add an open item. Ask a manager.',
  'error.DISCOUNT_EXCEEDS_AUTHORITY': 'That discount is beyond your limit. A manager must approve it.',
  'error.HOLD_CHANGED': 'That held bill changed a moment ago. Refresh the list and try again.',
  'error.network': 'The server could not be reached.',

  customer: 'Customer',
  choose: 'Choose customer',
  search: 'Search by mobile number or name',
  find: 'Find',
  cancel: 'Cancel',
  select: 'Use this customer',
  create: 'Save and select',
  newCustomer: 'New customer',
  details: 'More details',
  remove: 'Remove customer',
  duplicate: 'This mobile already belongs to this customer. Their details were not changed.',
  missing: 'No customer found. You can save a new customer.',
  saved: 'Customer saved',
  profile: 'Full profile',
  save: 'Save changes',
  reload: 'Reload profile',
  inactive: 'Inactive',
  active: 'Active customer',
  b2b: 'Business customer',
  history: 'Purchases and returns',
  previous: 'Previous',
  next: 'Next',
  noHistory: 'No transactions on this page.',
  invalidMobile: 'Enter a valid Indian mobile number.',
  invalidName: 'Enter a customer name.',
  requestFailed: 'Could not reach the server. Try again.',
  changed: 'This profile changed. Reload before saving.',
  current: 'Current customer',
  lookupFailed: 'Customer lookup failed. Try again.',
  outcomeUnknown: 'Sale outcome is unknown. Resolve this attempt before changing the bill.',
  resolve: 'Resolve saved-sale attempt',
  paymentCustomer: 'Change customer',
  totalsChanged: 'Customer changed. Review the total and your entered payments before completing.',
  confirmTotal: 'I have reviewed the updated total',
  name: 'Name',
  customerName: 'Customer name',
  phone: 'Mobile number',
  localName: 'Local / Tamil name',
  alternatePhone: 'Alternate mobile',
  email: 'Email',
  addressLine1: 'Address line 1',
  addressLine2: 'Address line 2',
  locality: 'Locality',
  city: 'City',
  state: 'State',
  stateCode: 'State code',
  pincode: 'Pincode',
  countryCode: 'Country code',
  gstin: 'GSTIN',
  businessName: 'Business name',
  birthday: 'Birthday (optional)',
  preferredLanguage: 'Preferred language',
  notes: 'Restricted notes',
  title: 'Customer profile',
  back: 'Back to customers',
  saving: 'Saving…',
  loading: 'Loading…',
  language: 'Language',
  unavailable: 'Customer profiles are not available for your account.',
  profileChanges: 'Changing this profile does not change issued invoices.',
} as const;
